import React from "react"
import './upcomingevents.css';
import templeevent from "../../data/templevent.json";

function UpcomingEvents() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const upcomingSpecialEvents = templeevent
        .filter((event) => event.display && event.specialevents)
        .map((event) => {
            const [year, month, day] = event.date.split('-').map(Number);
            return {
                ...event,
                _dateObj: new Date(year, month - 1, day),
            };
        })
        .filter((event) => event._dateObj >= today)
        .sort((a, b) => a._dateObj - b._dateObj);

    const nextEvent = upcomingSpecialEvents[0];
    const nextEventDate = nextEvent
        ? nextEvent._dateObj.toLocaleDateString(undefined, {
              month: "long",
              day: "numeric",
              year: "numeric",
          })
        : null;

    return (
        <section id="why-choose-289">
            <div class="cs-container">
                <div class="cs-content">
                    <div class="cs-flex">
                        <span class="cs-topper">Up Coming Events</span>
                        <h2 class="cs-title">{nextEvent ? nextEvent.title : "No upcoming special events"}</h2>
                    </div>
                    {nextEvent ? (
                        <p class="cs-item-text">
                            <h3 class="cs-h3">{nextEventDate} &nbsp; &nbsp; {nextEvent.time} </h3>
                            {nextEvent.description}
                        </p>
                    ) : (
                        <p class="cs-text">Please check back later for upcoming events.</p>
                    )}
                </div>
            </div>
        </section>
    );
}
export default UpcomingEvents;
    